import { reactive, computed } from '@vue/composition-api'
import { formatDate } from '@/util/common'

export const NoteDetailPart = (props, context) => {
  const store = context.root.$store
  const { note } = store.state

  const detail = reactive(computed(() => store.getters['note/detail']))

  const handleScrollChild = (e) => {
    context.emit('scroll', e)
  }

  const keyword = reactive(computed(() => note.search.keyword))

  const regExp = reactive(computed(() => {
    const lower = note.search.keyword.toString().toLowerCase()
    const keywordAry = lower.split(/\s+/)
    const words = keywordAry.join('|')
    const searchWord = note.search.keyword
      ? new RegExp('(' + words + ')', 'i')
      : null

    return searchWord
  }))

  const keywordSplit = reactive(computed(() => {
    if (!note.search.keyword) {
      return []
    }
    const lower = note.search.keyword.toString().toLowerCase()
    const keywordAry = lower.split(/\s+/)

    return keywordAry
  }))
  
  const share = reactive({
    /**
     * 閲覧/編集権限付与アカウント一覧ウィンドウを開く
     */
    openNoteUserPermissionsList: () => {
      context.emit('openNoteUserPermissionsList')
    }
  })

  const state = reactive({
    // タグエリア表示フラグ
    isTagAreaShown: computed(() => {
      // 自分が所有者である場合のみ表示
      return store.getters['note/isOwn']
    })
  })

  return {
    note,
    keyword,
    regExp,
    keywordSplit,
    share,
    state,
    detail,
    formatDate,
    handleScrollChild
  }
}
